/*
 * @Description: 路由
 * @Date: 2025-03-03 11:38:40
 */
export const route = [
  {
    path: '/main/project-mgmt-initiate-list',
    name: 'project-mgmt-initiate-list',
    meta: {
      title: '创建项目',
      parentPath: '/main/project-center-list'
    },
    component: () => import('../views/project-initiate-list.vue')
  }
];
